import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../shared/Navbar';

/**
 * App chrome for authenticated routes: the nav rail plus the routed page.
 * Mounted once by the router (see routes/AppRouter.tsx); pages must NOT
 * render their own <Navbar /> anymore.
 */
export const AppLayout: React.FC = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);
